import barcodeScannerMiddleware from './barcodeScannerMiddleware';

export default barcodeScannerMiddleware;
